import React, { useState, useEffect, useRef } from 'react';
import { AiOutlineFileText } from 'react-icons/ai';
import { BiSpreadsheet } from 'react-icons/bi';
import { IoMdAddCircle, IoMdRemoveCircle } from 'react-icons/io';
import ReactInputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';

import { Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';

import File from '~/components/Formik/File';
import Input from '~/components/Formik/Input';
import Modal from '~/components/Modal';
import Table from '~/components/Table';
import { useFiles } from '~/hooks/files';

import {
  Container,
  Content,
  ButtonsWrapper,
  AddButton,
  RemoveButton,
  InputSelect,
} from './styles';

const DynamicTable = ({ propTest, values, buttonName }) => {
  const dynamicTableColumns = useSelector(
    (state) => state.dynamicTable.dynamicTableColumns,
  );

  const loading = useSelector((state) => state.dynamicTable.loading);

  const {
    handleUpload,
    handleDownloadFile,
    historyFiles,
    uploadedFiles,
    handleDelete,
  } = useFiles();

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const [open, setOpen] = React.useState(false);

  const [rows, setRows] = useState([]);

  const [modal, setModal] = useState(false);

  const masks = {
    data: '99/99/9999',
  };

  const placeHolders = {
    data: '__/__/____',
    valor: 'R$:',
  };

  const handleAddRow = () => {
    const initialState = dynamicTableColumns.reduce((acc, obj) => {
      // eslint-disable-next-line no-param-reassign
      acc[obj.name] = '';
      return acc;
    }, {});
    setRows([...rows, initialState]);
  };

  const postResults = () => {
    const table = document.getElementById('teste');
    const inputs = table.querySelectorAll('input');

    inputs.forEach((input) => {
      if (input.validity.valueMissing) {
        input.style.border = '1px solid red';
      } else {
        input.style.border = '1px solid grey';
      }
    });

    const allFieldsFilled = Array.from(inputs).every(
      (input) => !input.required || input.value.trim() !== '',
    );

    if (allFieldsFilled) {
      setModal(false);
      propTest(rows); // there you go, do as you please
      setOpen(true);
    } else {
      toast.error('Erro na validação do formulário');
      // Faltam campos obrigatórios, impedir o envio e exibir uma mensagem de erro, se necessário.
      console.log('Preencha todos os campos obrigatórios antes de prosseguir!');
    }
  };
  const handleRemoveSpecificRow = (idx) => {
    if (idx !== 0) {
      const tempRows = [...rows]; // to avoid  direct state mutation

      tempRows.splice(idx, 1);

      setRows(tempRows);
    }
  };

  const updateState = (e) => {
    const prope = e.target.attributes.column.value; // the custom column attribute
    const index = e.target.attributes.index.value; // index of state array - rows
    let fieldValue;

    if (e.target.files) {
      // eslint-disable-next-line prefer-destructuring
      fieldValue = e.target.files[0].name;
      handleUpload([e.target.files[0]]);
    } else {
      fieldValue = e.target.value;
    }

    const tempRows = [...rows]; // avoid direct state mutation
    const tempObj = rows[index]; // copy state object at index to a temporary object
    tempObj[prope] = fieldValue; // modify temporary object

    // console.log('porps', fieldValue);

    if (prope === 'valor') {
      const numericInputVal = fieldValue.replace(/[^0-9]/g, '');

      // Formata para o formato de moeda (R$)
      const formattedValue = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(numericInputVal / 100);

      tempObj.valor = formattedValue; // Update "valor" property with the formatted value
    } else if (prope === 'data') {
      const dateInputVal = fieldValue.replace(/[^0-9]/g, ''); // Remove caracteres não numéricos

      // Adiciona '__/__/__' no input se a data não estiver completa (menos de 8 dígitos)
      let formattedDate = '__/__/__';

      if (dateInputVal.length <= 8) {
        // Extrai os valores de dia, mês e ano da string numérica
        const day = dateInputVal.substring(0, 2);
        const month = dateInputVal.substring(2, 4);
        const year = dateInputVal.substring(4, 8);

        // Formata a data no formato "dd/mm/aaaa"
        formattedDate = `${day}/${month}/${year}`;
      }

      tempObj.data = formattedDate; // Update "data" property with the formatted date
    }

    // return object to rows` clone
    tempRows[index] = tempObj;

    setRows(tempRows); // update state
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const renderFileLink = (id, path) => (
    <button type="button" key={id} onClick={() => handleDownloadFile(path)}>
      <AiOutlineFileText size={24} color="red" />
      <span>{path}</span>
    </button>
  );

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  useEffect(() => {
    if (dynamicTableColumns !== undefined) {
      const obj = {};
      dynamicTableColumns.forEach((key) => {
        obj[key.name] = '';
        setRows([obj]);
      });
    }
  }, [dynamicTableColumns]);

  useEffect(() => {
    if (values) {
      const json = JSON.parse(values);
      setRows(json);
    }
  }, [values, dynamicTableColumns]);

  const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
  ];

  const whichInputToRender = (column, index, idx, item) => {
    if (column.type === 'file') {
      const matchingUploadedFile = uploadedFiles.find(
        (file) => file.name === item.codigo,
      );
      if (historyFiles.length > 0) {
        const matchingFile = historyFiles.find(
          (file) => file.name === item.codigo,
        );

        if (matchingFile) {
          return renderFileLink(matchingFile.id, matchingFile.key);
        }
      }

      if (matchingUploadedFile) {
        return (
          <>
            <span>{matchingUploadedFile.name}</span>
            <button
              type="button"
              onClick={() => handleDelete([matchingUploadedFile.key])}
            >
              Excluir
            </button>
          </>
        );
      }
      return (
        <input
          id={column.name}
          type="file"
          name={column.name}
          column={column.name}
          // value={item[column.name.trim()]}
          index={idx}
          onChange={(e) => updateState(e)}
        />
      );
    }

    if (column.type === 'list') {
      return (
        <select
          style={{
            width: '80%',
            borderRadius: '5px',
            border: '1px solid #b3b3b3',
            background: 'transparent',
            height: '25px',
            padding: '0 2px',
            transition: 'border 0.3s',
          }}
          required
          name={column.name}
          column={column.name}
          value={item[column.name.trim()]}
          index={idx}
          onChange={(e) => updateState(e)}
        >
          <option value="" disabled>
            Selecione uma opção
          </option>
          {options.map((option) => (
            <option value={option.value}>{option.label}</option>
          ))}
        </select>
      );
    }

    // if (uploadedFiles.length > 0) {
    //   let matchingFile = uploadedFiles.find(
    //     (file) => file.name === item.codigo,
    //   );

    //   if (matchingFile) {
    //     console.log('matchingFile', matchingFile);
    //     return (
    //       <div
    //         style={{
    //           display: 'flex',
    //           alignItems: 'center',
    //           justifyContent: 'center',
    //         }}
    //       >
    //         <button
    //           style={{
    //             background: 'transparent',
    //             border: 'none',
    //             color: 'red',
    //           }}
    //           type="button"
    //           onClick={() => {
    //             handleDelete([matchingFile.key]);
    //             matchingFile = undefined;
    //             console.log('matchingFile', matchingFile);
    //           }}
    //         >
    //           excluir
    //         </button>
    //       </div>
    //     );
    //   }

    //   console.log('matchingFile', matchingFile);
    // }

    return (
      <ReactInputMask
        name={column.name}
        column={column.name}
        value={item[column.name.trim()]}
        index={idx}
        type={column.type}
        mask={masks[column.type]}
        placeholder={placeHolders[column.type]}
        onChange={(e) => updateState(e)}
        required
      />
    );

    // column.validation === 'true' ? (
    //   <ReactInputMask
    //     name={column.name}
    //     column={column.name}
    //     value={item[column.name.trim()]}
    //     index={idx}
    //     type={column.type}
    //     mask={masks[column.type]}
    //     placeholder={placeHolders[column.type]}
    //     onChange={(e) => updateState(e)}
    //     required
    //   />
    // ) : (
    //   <ReactInputMask
    //     name={column.name}
    //     column={column.name}
    //     value={item[column.name.trim()]}
    //     index={idx}
    //     type={column.type}
    //     mask={masks[column.type]}
    //     placeholder={placeHolders[column.type]}
    //     onChange={(e) => updateState(e)}
    //   />
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        message="Dados salvos!"
        action={action}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ zIndex: 99999 }}
      />

      <Modal
        disableScrollBar
        open={modal}
        modalState={(opened) => setModal(opened)}
      >
        <Container>
          <Content>
            <Table>
              <thead>
                <tr>
                  <th> # </th>
                  {!loading &&
                    dynamicTableColumns?.map((column, index) => (
                      <th key={index}>{column.name}</th>
                    ))}
                  <td />
                </tr>
              </thead>
              <tbody id="teste">
                {rows?.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    {!loading &&
                      dynamicTableColumns?.map((column, index) => (
                        <td key={index}>
                          {whichInputToRender(column, index, idx, item)}
                          {/* <Form
                              id="form-teste"
                              ref={formTableRef}
                              onSubmit={formik.handleSubmit}
                            > */}
                          {/* <input
                                type="text"
                                id={column.name}
                                value={item[column.name.trim()]}
                                onChange={(e) => setTeste(e.target.value)}
                              /> */}

                          {/* <Select
                                optional
                                name="parent_id"
                                placeholder="Selecione a lista relacionada"
                                label="Lista relacionada"
                                isClearable
                                backspaceRemovesValue
                                getOptionLabel={(data) => data.name}
                                getOptionValue={(data) => data.id}
                                options={options.map((group) => ({
                                  value: group,
                                  label: group,
                                }))}
                                value={item[column.name.trim()]}
                                o onChange={(e) => updateState(e)}
                              /> */}

                          {/* <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isClearable
                            name="color"
                            options={options}
                            onChange={(e) => updateState(e.value)}
                            requiered
                          /> */}
                          {/* </Form> */}
                        </td>
                      ))}
                    <td>
                      <RemoveButton
                        onClick={() => handleRemoveSpecificRow(idx)}
                        type="button"
                      >
                        <IoMdRemoveCircle color="white" size={20} />
                      </RemoveButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Content>
          <ButtonsWrapper>
            <AddButton type="button" onClick={handleAddRow}>
              <IoMdAddCircle size={20} /> Novo
            </AddButton>
            <Button
              onClick={postResults}
              variant="contained"
              style={{ background: 'rgb(235, 0, 69)', color: 'white' }}
              type="button"
            >
              Salvar
            </Button>
          </ButtonsWrapper>
        </Container>
      </Modal>
      <Button
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '120px',
          border: '1px solid #e6e6e6',
          borderRadius: '5px',
          color: 'rgb(235, 0, 69)',
        }}
        onClick={() => setModal(!modal)}
        type="button"
        disabled={loading}
      >
        {buttonName}
        <BiSpreadsheet size={24} color="black" />
      </Button>
    </>
  );
};

export default DynamicTable;
